import { render, staticRenderFns } from "./creazioniMultiple.vue?vue&type=template&id=258850ad"
import script from "./creazioniMultiple.vue?vue&type=script&lang=js"
export * from "./creazioniMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports